import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-4';
import { Puff } from 'react-loader-spinner';

import { logger, remCss, scssVariables as variables } from 'src/helpers';

class MCScrollbar extends React.PureComponent {
  warn = logger.warn.bind(logger, 'MCScrollbar');
  constructor(props) {
    super(props);

    this.scrollbars = React.createRef();
    this.prevScrollState = this.scrollState = {
      scrollInNewest: false,
      scrollClientHeight: 0,
      scrollHeight: 0,
      scrollTop: 0,
      viewable: {
        viewableItems: [],
        changed: []
      },
      keyIdentify: null
    };
  }

  state = {
    scrollInNewest: true
  };

  scrollToNewest = () => {
    console.log('scrollToNewest');
    this.props.inverted ? this.scrollbars.scrollToBottom() : this.scrollbars.scrollTop();
    setTimeout(() => {
      this.props.inverted ? this.scrollbars.scrollToBottom() : this.scrollbars.scrollTop();
    }, 0);
  };

  isOnNewest = () => !!this.scrollState.scrollInNewest;

  // handle scroll change
  handleScroll = ({ scrollTop, scrollHeight, clientHeight }) => {
    const {
      keyIdentify,
      loadMore,
      hasMore,
      loadNewer,
      hasNewer,
      loading,
      inverted,
      scrollToLastRead,
      offset = 15
    } = this.props;
    let apiLoading = loading;
    // ignore scroll change caused by loading bar
    if (apiLoading) return;
    let isTop = scrollHeight < clientHeight || scrollTop < offset;
    let isBottom =
      scrollHeight < clientHeight || scrollHeight - scrollTop <= clientHeight + offset + 40;
    let scrollInOldest = inverted ? isTop : isBottom;
    let scrollInNewest = inverted ? isBottom : isTop;
    let prevState = (this.prevScrollState = this.scrollState);
    let curState = (this.scrollState = {
      scrollHeight,
      clientHeight,
      scrollTop,
      isTop,
      isBottom,
      scrollInOldest,
      scrollInNewest,
      keyIdentify,
      loading,
      waiting: prevState.waiting,
      waitingOlder: prevState.waitingOlder,
      waitingNewer: prevState.waitingNewer,
      viewable: prevState.viewable,
      date: Date.now()
    });
    let scrollHeightChange = curState.scrollHeight - prevState.scrollHeight;
    let scrollTopChange = curState.scrollTop - prevState.scrollTop;
    let dateChange = curState.date - prevState.date;
    let listChanged = keyIdentify && curState.keyIdentify !== prevState.keyIdentify;
    if (!apiLoading && !curState.waiting) this._calculateViewable();
    // if scroll height increased, check if need to scroll to another position
    if (scrollHeightChange !== 0 && listChanged) {
      // if list changed, scroll to last read (if set) or newest
      this.warn('scroll after new list opened', { prevState, curState });
      scrollToLastRead ? scrollToLastRead() : this.scrollToNewest();
    } else if (scrollHeightChange > 0) {
      // last position if added newer
      let lastPosition = inverted ? prevState.scrollTop : scrollHeightChange + prevState.scrollTop;
      if (!apiLoading && prevState.waiting) {
        // if loaded older or newer, keep scroll on same position
        if (curState.waitingOlder) {
          // last position if added older
          lastPosition = !inverted ? prevState.scrollTop : scrollHeightChange + prevState.scrollTop;
        }
        curState.waiting = false;
        curState.waitingOlder = false;
        curState.waitingNewer = false;
        this.warn('loaded, scrolling to original position', {
          prevState,
          curState,
          lastPosition,
          inverted,
          scrollHeightChange
        });
        this.scrollbars.scrollTop(lastPosition);
      } else if (prevState.scrollInNewest && !curState.scrollInNewest) {
        // if scroll was on newest item and new added, keep it on newest
        this.warn('scroll to newest after new added', { prevState, curState });
        this.scrollToNewest();
      } else if (!curState.scrollInNewest && dateChange > 50) {
        // if scroll was in midle and new added, keep scroll on same position
        // lastPosition = prevState.scrollTop;
        this.warn('added new, scrolling to original position', {
          prevState,
          curState,
          lastPosition,
          inverted,
          scrollHeightChange,
          dateChange
        });
        this.scrollbars.scrollTop(lastPosition);
      }
    } else if (
      scrollTopChange !== 0 &&
      !apiLoading &&
      !curState.waiting &&
      scrollHeight > clientHeight
    ) {
      // if reached start or end, check if need to load older or newer
      if (scrollInOldest && hasMore && loadMore) {
        this.warn('scroll loadMore', { prevState, curState });
        curState.waitingOlder = curState.waiting = !!loadMore();
      } else if (scrollInNewest && hasNewer && loadNewer) {
        this.warn('scroll loadNewer', { prevState, curState });
        curState.waitingNewer = curState.waiting = !!loadNewer();
      } else {
        // this.warn('nothing changed', { prevState, curState });
      }
    } else {
      // this.warn('nothing changed', { prevState, curState });
    }
    if (curState.scrollInNewest !== this.state.scrollInNewest)
      this.setState({ scrollInNewest: curState.scrollInNewest });
  };

  // calculate viewable items during scroll
  _calculateViewable = () => {
    let { onViewableItemsChanged } = this.props;
    let { viewable } = this.scrollState;
    let viewableItems = viewable.viewableItems;
    let items = this.props.data;
    if (!(items && items.length > 0)) return;
    let containerRect = this.scrollbars.view.getBoundingClientRect();
    let newViewableItems = items.filter((item) => {
      let { top, height } = item.ref ? item.ref.getBoundingClientRect() : { top: -1, height: 0 };
      return top >= containerRect.top && top + height <= containerRect.bottom;
    });
    let changed = newViewableItems.filter((item) => viewableItems.indexOf(item) === -1);
    if (changed.length > 0) {
      let newViewable = { viewableItems: newViewableItems, changed };
      this.prevScrollState.viewable = this.scrollState.viewable;
      this.scrollState.viewable = newViewable;
      onViewableItemsChanged && onViewableItemsChanged(newViewable);
    } else {
      // this.log('viewable not changed', newViewableItems.length);
    }
  };

  renderLoadingbar = (isFull) => {
    return (
      <div className={`mc-scrollbar-spinner ${isFull && 'full'}`}>
        {/*<ClapSpinner frontColor={variables['colors-mc-primary']} backColor='#1da1f2' size={30} />*/}
        <Puff
          wrapperStyle={{ justifyContent: 'center' }}
          color={variables['colors-mc-primary']}
          height={remCss(20)}
          width={remCss(20)}
        />
      </div>
    );
  };

  renderEmptyItem = (message) => {
    return <div className='mc-scrollbar-endMessage'>{message || 'No Items'}</div>;
  };

  onRef = (ref) => {
    this.props.scrollRef && this.props.scrollRef(ref);
    this.scrollbars = ref;
  };

  render() {
    const {
      children,
      loading = false,
      endMessage = null,
      inverted,
      data = [],
      dataLength,
      renderItem = null,
      listContainerClass = null,
      fullSpinner,
      renderUnreadCounter,
      footer
    } = this.props;
    let { scrollInNewest } = this.state;
    const dataList = inverted ? [...data].reverse() : data;
    const showNotItems = !loading && !dataLength && !data.length && !!endMessage;
    // this.warn('keyIdentify', keyIdentify);
    return (
      <React.Fragment>
        {fullSpinner && loading && this.renderLoadingbar(true)}
        {renderUnreadCounter && !scrollInNewest && renderUnreadCounter()}
        <Scrollbars
          ref={this.onRef}
          renderView={(props) => (
            <div {...props} className={`mc-scrollbar ${inverted && 'inverted'}`} />
          )}
          renderTrackVertical={(props) => <div {...props} className='track-vertical' />}
          renderThumbVertical={(props) => <div {...props} className='thumb-vertical' />}
          renderTrackHorizontal={(props) => <div {...props} className='track-horizontal' />}
          renderThumbHorizontal={(props) => <div {...props} className='thumb-horizontal' />}
          autoHide={true}
          // {...rest}
          onUpdate={this.handleScroll}
        >
          <div className={`mc-scrollbar-container ${inverted && 'inverted'}`}>
            {renderItem && (
              <ul className={listContainerClass || 'mc-list'}>
                {dataList.map((item, index) => renderItem({ item, index }))}
              </ul>
            )}
            {children}
            {!fullSpinner && loading && this.renderLoadingbar()}
          </div>
          {showNotItems && this.renderEmptyItem(endMessage)}
          {!!footer && footer()}
        </Scrollbars>
      </React.Fragment>
    );
  }
}

export default MCScrollbar;
